import thunk from 'redux-thunk';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { uiReducer } from '../catalog/reducers/ui';
import { quickViewModalReducer } from '../catalog/reducers/quickViewModal';
import { createCatalogRenderer } from '../catalog/components/CatalogRenderer';

const data = serverVars.get('catalog.preloadedData');
const params = serverVars.get('catalog.preloadedState');

const options = {
    middleware: [thunk],
    reducers: {
        ui: uiReducer,
        qv: quickViewModalReducer,
    },
};

initializeDBL(options).then(({ store }) => {
    createCatalogRenderer({
        ...data,
        ...params,
        store,
        containerId: 'js-root',
    });
});
